export default __webpack_public_path__ + "static/car-4c9f02d4d65a8140490bc38953b30fd2.png";